var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-header-page': !_vm.noCommonHeader },attrs:{"id":"app"}},[(!_vm.noCommonHeader)?_c('commonHeader'):_vm._e(),_c('div',{class:{ 'has-header-content': !_vm.noCommonHeader }},[_c('router-view')],1),(!_vm.noCommonFooter)?_c('commonFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }